import {Menu, MenuProps} from '@headlessui/react';
import {ChevronDownIcon} from '@heroicons/react/24/solid';
import React from 'react';

import * as tw from 'src/lib/tailwindClasses';

export type DropdownItem = {
  props: React.ButtonHTMLAttributes<HTMLButtonElement>;
  text: string;
  divider?: boolean;
  icon?: React.ReactNode;
};

type Props = {
  title: string;
  items: DropdownItem[];
  minimal?: boolean;
  link?: boolean;
  itemWidth?: number;
  props?: MenuProps<'div'>;
};

export default function Dropdown({
  props: menuProps,
  title,
  items,
  minimal,
  link,
  itemWidth = 120,
}: Props) {
  return (
    <Menu as="div" className="relative inline-block text-right" {...menuProps}>
      {link ? (
        <Menu.Button className="text-blue-600">{title}</Menu.Button>
      ) : (
        <Menu.Button
          className={`${
            minimal ? 'text-xs' : `${tw.ringBorder}  text-sm`
          } inline-flex justify-center px-4 py-2 w-full font-medium`}
        >
          {title}
          <ChevronDownIcon className="h-4 w-4 pt-1" />
        </Menu.Button>
      )}

      <Menu.Items
        className="absolute right-0  m-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-20"
        style={{width: itemWidth}}
      >
        {items.map(({props, text, divider, icon}, i) => (
          <React.Fragment key={i}>
            {divider && <div className="border-t border-gray-200 my-1" />}
            <Menu.Item>
              <button
                className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 text-left"
                {...props}
              >
                {icon}
                {text}
              </button>
            </Menu.Item>
          </React.Fragment>
        ))}
      </Menu.Items>
    </Menu>
  );
}
